import type { TranslationKeys } from '../types';

export const hi: TranslationKeys = {
  nav: { home: 'होम', about: 'हमारे बारे में', faq: 'सामान्य प्रश्न', pricing: 'मूल्य', howToUse: 'कैसे उपयोग करें', giftStore: 'उपहार स्टोर', blog: 'ब्लॉग', login: 'लॉग इन', signup: 'साइन अप', dashboard: 'डैशबोर्ड', logout: 'लॉग आउट' },
  hero: { tagline: 'प्यार अभी व्यक्त करें, बाद में नहीं।', headline: 'वो बातें कहें जो कहना सबसे मुश्किल है — बिना आमने-सामने बातचीत के दबाव के।', subheadline: 'अपने दिल की बात लिखें या रिकॉर्ड करें, टोन को सही करें, और सही समय पर भेजें।', cta: 'अभी कहें', ctaSecondary: 'उदाहरण देखें', socialProof: 'दिल से संदेश साझा किए गए' },
  values: {
    title: 'लिविंग अनाउंसमेंट क्यों?',
    problem: { title: 'सबसे महत्वपूर्ण शब्द', description: 'हम अक्सर अपने सबसे गहरे शब्द अपने पास रखते हैं, बिना कहे। Say It NOW आपको अपने समय पर, अपने तरीके से प्यार और कृतज्ञता व्यक्त करने में मदद करता है।' },
    solution: { title: 'सुंदर, साझा करने योग्य यादें', description: 'फोटो और दिल की बातों के साथ मैगज़ीन-स्टाइल डिजिटल संदेश बनाएं जो आपके प्रियजन संजो सकें।' },
    impact: { title: 'हर पल को खास बनाएं', description: 'अपनी भावनाओं को शानदार दृश्य कहानियों में बदलें जो आपके प्रियजनों का जश्न मनाएं।' },
  },
  templates: {
    title: 'हर कहानी के लिए शानदार टेम्पलेट',
    subtitle: 'खूबसूरती से डिज़ाइन किए गए लेआउट चुनें जो आपके शब्दों को जीवंत करें।',
    classicElegance: 'क्लासिक एलिगेंस',
    modernWarmth: 'मॉडर्न वार्मथ',
    boldStatement: 'बोल्ड स्टेटमेंट',
    intimateJournal: 'इंटिमेट जर्नल',
  },
  howItWorks: {
    title: 'यह कैसे काम करता है',
    step1: { title: 'अपनी फोटो चुनें', description: '1-3 意味वाली फोटो चुनें जो आपके रिश्ते को दर्शाती हों।' },
    step2: { title: 'अपना संदेश लिखें', description: 'गाइडेड प्रॉम्प्ट की मदद से सही शब्द खोजकर अपना प्यार व्यक्त करें।' },
    step3: { title: 'टेम्पलेट चुनें', description: '4 शानदार मैगज़ीन-स्टाइल लेआउट में से चुनें।' },
    step4: { title: 'प्यार साझा करें', description: 'अपना लिविंग अनाउंसमेंट लिंक या सोशल मीडिया से भेजें।' },
  },
  howToUse: {
    title: 'Say It NOW कैसे उपयोग करें',
    subtitle: 'जानें कि उन लोगों के साथ प्यार और कृतज्ञता साझा करना कितना आसान है जो सबसे ज़्यादा मायने रखते हैं',
    create: {
      title: 'अपना लिविंग अनाउंसमेंट बनाएं',
      subtitle: '5 आसान चरणों में प्यार व्यक्त करें',
      step1: { label: 'फोटो अपलोड करें', desc: '3 तक मायने रखने वाली फोटो जोड़ें' },
      step2: { label: 'रिश्ता चुनें', desc: 'माता-पिता, दादा-दादी, दोस्त, और अधिक' },
      step3: { label: 'अपना संदेश लिखें', desc: 'AI सही शब्द खोजने में मदद कर सकता है' },
      step4: { label: 'टेम्पलेट चुनें', desc: 'क्लासिक, मॉडर्न, बोल्ड, या जर्नल' },
      step5: { label: 'प्रीव्यू और पब्लिश', desc: 'प्राइवेट या पब्लिक लिंक से साझा करें' },
    },
    dashboard: {
      title: 'अपने अनाउंसमेंट प्रबंधित करें',
      subtitle: 'आपका व्यक्तिगत डैशबोर्ड',
      viewAll: { label: 'सभी देखें', desc: 'अपने सभी लिविंग अनाउंसमेंट एक जगह देखें' },
      editAnytime: { label: 'कभी भी संपादित करें', desc: 'फोटो, संदेश और टेम्पलेट अपडेट करें' },
      copyLinks: { label: 'लिंक कॉपी करें', desc: 'अपने अनाउंसमेंट आसानी से साझा करें' },
      viewAsMagazine: 'मैगज़ीन के रूप में देखें',
    },
    aiFeatures: {
      title: 'AI-संचालित सुविधाएं',
      subtitle: 'तकनीक को जुड़े रहने में मदद करने दें',
      messageWriting: { label: 'AI संदेश लेखन', desc: 'शब्द नहीं मिल रहे? AI दिल से संदेश लिखने में मदद करता है' },
      reminders: { label: 'हार्टफेल्ट रिमाइंडर', desc: 'जब आप कुछ समय से जुड़े नहीं हैं तो कोमल संकेत' },
      autoCompose: { label: 'ऑटो-कंपोज़', desc: 'AI आपकी स्वीकृति के लिए अनाउंसमेंट बनाता है' },
    },
    gamification: {
      title: 'बैज अर्जित करें और लेवल अप करें',
      subtitle: 'प्यार की अपनी यात्रा का जश्न मनाएं',
      levelsTitle: 'लेवल में आगे बढ़ें',
      badgesTitle: 'बैज इकट्ठा करें',
      levels: {
        heartOpener: 'हार्ट ओपनर',
        soulConnector: 'सोल कनेक्टर',
        loveAmbassador: 'लव एम्बेसडर',
        gratitudeChampion: 'ग्रैटिट्यूड चैंपियन',
        legacyMaker: 'लीगेसी मेकर',
      },
      badges: {
        firstExpression: 'पहली अभिव्यक्ति',
        loveAmbassador: 'लव एम्बेसडर',
        birthdayChampion: 'बर्थडे चैंपियन',
        consistencyStar: 'कंसिस्टेंसी स्टार',
      },
      jacKeyLines: {
        firstExpression: 'एक बार आना सब बदल सकता है।',
        relationshipCelebrant: 'कुछ रिश्ते ऐसे शब्दों के हकदार हैं जो ज़ोर से कहे जाएं।',
        birthdayChampion: 'तारीखें याद रखना प्यार दिखाने का एक तरीका है।',
        friendshipKeeper: 'लंबी दोस्ती याद किए जाने से बनती है।',
        consistencyStar: 'जुड़ाव शांत निरंतरता से बढ़ता है।',
        loveAmbassador: 'आप बार-बार उपस्थित होने का चुनाव कर रहे हैं।',
      },
      helperMicrocopy: 'सुझाव: किसी भी बैज पर होवर करें यह देखने के लिए कि यह कैसे अर्जित होता है।',
      progressContext: {
        nextMilestone: 'अगला मील का पत्थर: {level} तक {points} अंक।',
        maxLevel: 'आपने कुछ स्थायी बनाया है।',
      },
      yourBadges: 'आपके बैज',
      pointsTotal: '{points} कुल अंक',
      ptsToGo: '{points} अंक शेष',
      achieved: 'प्राप्त!',
      next: 'अगला:',
      progressEncouragement: 'आप प्रगति कर रहे हैं! और बैज अनलॉक करने के लिए प्यार व्यक्त करते रहें।',
      quietModeOn: 'शांत मोड चालू है',
      tiers: { awareness: 'जागरूकता', presence: 'उपस्थिति', continuity: 'निरंतरता', beyond: 'परे' },
      ptsTo: '{tier} तक {points} अंक',
      highestTier: 'आपने सबसे ऊंचा स्तर प्राप्त कर लिया है!',
      softEncouragement: {
        message: 'कई लोगों को एहसास होता है कि उन्हें और भी बहुत कुछ कहना है।',
        cta: 'बातचीत जारी रखें',
        dismiss: 'शायद बाद में',
      },
    },
  },
  examples: {
    title: 'लिविंग अनाउंसमेंट को क्रिया में देखें',
    subtitle: 'प्यार के असली संदेश, सुंदरता से प्रस्तुत। अभी कृतज्ञता व्यक्त करने के प्रभाव को देखने के लिए स्वाइप करें।',
    to: 'प्रति',
    from: 'प्यार से',
  },
  video: {
    badge: 'हमारा समुदाय',
    title: 'Say It NOW क्यों मायने रखता है',
    subtitle: 'असली लोग, असली कहानियां। जब यह सबसे ज़्यादा मायने रखता है तब प्यार व्यक्त करने के आंदोलन में खुद को देखें।',
    playButton: 'हमारी कहानी देखें',
    stat1: 'संदेश साझा किए गए',
    stat2: 'देश पहुंचे',
    stat3: 'जीवन छुए',
  },
  pricing: {
    title: 'सरल, पारदर्शी मूल्य',
    subtitle: 'चुनें कि आप कैसे दिखना चाहते हैं। मुफ़्त में शुरू करें, कभी भी और जोड़ें।',
    popular: 'अनुशंसित',
    guarantee: '💛 आपके शब्द सुरक्षित हैं। आप कभी भी उन पर लौट सकते हैं।',
    monthly: 'मासिक',
    annual: 'वार्षिक',
    savePercent: '20% बचाएं',
    plans: {
      free: {
        name: 'एक बार कहें',
        price: '$0',
        period: '/मुफ़्त',
        description: 'एक सुंदर पल',
        features: ['3 मुफ़्त अनाउंसमेंट', 'बेसिक मैगज़ीन-स्टाइल डिज़ाइन', '1-3 फोटो अपलोड करें', 'पब्लिक या प्राइवेट शेयरिंग लिंक', 'सीमित AI सहायता (2 उपयोग)', 'Say It NOW वॉटरमार्क शामिल'],
        cta: 'अपना पल शुरू करें',
      },
      plus: {
        name: 'कनेक्शन',
        price: '$17',
        period: 'एक बार',
        annualPrice: '$17',
        annualPeriod: 'एक बार',
        description: 'जब ज़रूरी हो तब दिखें',
        features: ['+10 अनाउंसमेंट', 'स्टार्टर में सब कुछ', 'शेड्यूलिंग और ईमेल रिमाइंडर', 'पूर्ण AI लेखन सहायता', 'वॉटरमार्क हटाएं'],
        cta: 'कनेक्शन चुनें',
      },
      legacy: {
        name: 'लीगेसी',
        price: '$35',
        period: 'एक बार',
        annualPrice: '$35',
        annualPeriod: 'एक बार',
        description: 'इसे एक सार्थक अभ्यास बनाएं',
        features: ['+25 अनाउंसमेंट', 'सब कुछ शामिल', 'वार्षिक अनाउंसमेंट दोहराएं', 'TRESLOG एक्सेस', 'डाउनलोड करने योग्य कीपसेक', 'वीडियो संदेश'],
        cta: 'लीगेसी चुनें',
      },
    },
  },
  cta: {
    badge: 'जब आप तैयार हों',
    title: 'जो मायने रखता है वो साझा करें, अपने समय पर',
    subtitle: 'जिन लोगों से आप प्यार करते हैं वे जानने के हकदार हैं कि आप कैसा महसूस करते हैं। मिनटों में अपना पहला लिविंग अनाउंसमेंट बनाएं — भुगतान की ज़रूरत नहीं।',
    button: 'मुफ़्त अनाउंसमेंट बनाएं',
    viewPricing: 'विकल्प देखें',
    noCard: '💛 क्रेडिट कार्ड की ज़रूरत नहीं • मुफ़्त प्लान उपलब्ध',
  },
  footer: {
    tagline: 'प्यार अभी व्यक्त करें, बाद में नहीं।',
    about: 'हमारे बारे में',
    faq: 'सामान्य प्रश्न',
    pricing: 'मूल्य',
    howToUse: 'कैसे उपयोग करें',
    giftStore: 'उपहार स्टोर',
    privacy: 'गोपनीयता',
    terms: 'शर्तें',
    contact: 'संपर्क',
    copyright: '© 2026 Say It NOW. सर्वाधिकार सुरक्षित।',
  },
  auth: {
    loginTitle: 'वापस स्वागत है',
    loginSubtitle: 'लिविंग अनाउंसमेंट बनाना जारी रखने के लिए साइन इन करें',
    signupTitle: 'Say It NOW से जुड़ें',
    signupSubtitle: 'उन लोगों के लिए प्यार व्यक्त करना शुरू करें जो सबसे ज़्यादा मायने रखते हैं',
    email: 'ईमेल',
    password: 'पासवर्ड',
    confirmPassword: 'पासवर्ड की पुष्टि करें',
    fullName: 'पूरा नाम',
    loginButton: 'साइन इन',
    signupButton: 'अकाउंट बनाएं',
    forgotPassword: 'पासवर्ड भूल गए?',
    noAccount: 'अकाउंट नहीं है?',
    hasAccount: 'पहले से अकाउंट है?',
    orContinueWith: 'या जारी रखें',
    google: 'Google',
    apple: 'Apple',
    resetPassword: 'पासवर्ड रीसेट करें',
    resetPasswordSubtitle: 'पासवर्ड रीसेट लिंक प्राप्त करने के लिए अपना ईमेल दर्ज करें',
    sendResetLink: 'रीसेट लिंक भेजें',
    backToLogin: 'लॉगिन पर वापस',
    newPassword: 'नया पासवर्ड सेट करें',
    newPasswordSubtitle: 'नीचे अपना नया पासवर्ड दर्ज करें',
    newPasswordLabel: 'नया पासवर्ड',
    confirmNewPassword: 'नए पासवर्ड की पुष्टि करें',
    passwordMismatch: 'पासवर्ड मेल नहीं खाते',
    passwordUpdated: 'पासवर्ड अपडेट हो गया!',
    passwordUpdatedSubtitle: 'आपका पासवर्ड सफलतापूर्वक अपडेट हो गया है। अब आप अपने नए पासवर्ड से साइन इन कर सकते हैं।',
    updatePasswordButton: 'पासवर्ड अपडेट करें',
    resetLinkExpired: 'यह रीसेट लिंक समाप्त हो गया होगा या पहले ही उपयोग किया जा चुका है। कृपया नया अनुरोध करें।',
  },
  common: {
    loading: 'लोड हो रहा है...',
    error: 'कुछ गलत हो गया',
    retry: 'फिर कोशिश करें',
    cancel: 'रद्द करें',
    save: 'सेव करें',
    delete: 'हटाएं',
    edit: 'संपादित करें',
    create: 'बनाएं',
    share: 'साझा करें',
    preview: 'प्रीव्यू',
    publish: 'प्रकाशित करें',
    draft: 'ड्राफ्ट',
    pending: 'समीक्षा लंबित',
    approved: 'स्वीकृत',
    rejected: 'अस्वीकृत',
  },
  about: {
    badge: 'हमारा उद्देश्य',
    title: 'Say It NOW क्यों मौजूद है',
    subtitle: 'क्योंकि प्यार को श्रद्धांजलि बनने से पहले व्यक्त किया जाना चाहिए।',
    story1: 'इस ऐप को बनाने का पूरा उद्देश्य इंसानों के बीच बेहतर जुड़ाव प्रदान करना है। अक्सर हम किसी व्यक्ति के बारे में सुनते नहीं कि वे कितने महान और अद्भुत थे जब तक वे चले नहीं जाते।',
    story2: 'वर्षों से, मैंने हाल ही में गुज़रे व्यक्ति के पेज पर कई पोस्ट देखी हैं, लेकिन जब आप उनकी कहानी का इतिहास देखते हैं, किसी ने भी वे बातें उस व्यक्ति से नहीं कही थीं।',
    story3: 'हम नहीं जानते कि परलोक में कोई आत्मा वास्तव में वह पोस्ट देखती है या नहीं... मैं अक्सर सोचता था।',
    story4: 'यह वेब ऐप व्यक्तियों को अवसर देता है और उन्हें याद दिलाता है कि जब वह व्यक्ति अभी भी जीवित है और दयालु शब्दों की सराहना कर सकता है, तब अपनी भावनाएं व्यक्त करें।',
    story5: 'लेकिन ज़िंदगी चलती रहती है और लोग व्यस्त हो जाते हैं और भूल जाते हैं। अब नहीं...',
    highlight: 'कभी-कभी, लोगों को बस यह जानने की ज़रूरत होती है कि कोई है जो उनकी परवाह करता है और उन्हें दुनिया का सबसे अच्छा इंसान मानता है।',
    mission: 'Say It NOW इसलिए विकसित किया गया ताकि एक व्यक्ति इस दुनिया से यह जानकर जा सके कि वे कितने प्यारे, सराहे और महान हैं।',
    valuesTitle: 'हमारे मूल मूल्य',
    value1Title: 'अभी प्यार व्यक्त करें',
    value1Desc: 'अंतिम संस्कार का इंतज़ार न करें यह बताने के लिए कि कोई आपके लिए कितना मायने रखता है।',
    value2Title: 'मानवीय जुड़ाव',
    value2Desc: 'सार्थक शब्दों के माध्यम से दिलों के बीच पुल बनाना।',
    value3Title: 'मानसिक स्वास्थ्य',
    value3Desc: 'यह जानना कि आप प्यार और सराहे जाते हैं, मानसिक स्वास्थ्य में सुधार करता है।',
    value4Title: 'जीवन में याद किए जाना',
    value4Desc: 'हर किसी को उनकी कीमत जानने में मदद करना जब वे अभी भी सुन सकते हैं।',
    ctaTitle: 'अपना प्यार व्यक्त करने के लिए तैयार हैं?',
    ctaSubtitle: 'आज ही सुंदर लिविंग अनाउंसमेंट बनाना शुरू करें। किसी का दिन रोशन करने में बस कुछ मिनट लगते हैं।',
    ctaButton: 'मुफ़्त शुरू करें',
    ctaSecondary: 'मूल्य देखें',
  },
  faq: {
    badge: 'सहायता केंद्र',
    title: 'अक्सर पूछे जाने वाले प्रश्न',
    subtitle: 'Say It NOW के बारे में वह सब कुछ जो आपको जानना चाहिए और यह कैसे आपको प्यार व्यक्त करने में मदद करता है जब यह सबसे ज़्यादा मायने रखता है।',
    categoryGeneral: 'सामान्य प्रश्न',
    categoryFeatures: 'सुविधाएं और प्लान',
    categoryPrivacy: 'गोपनीयता और साझाकरण',
    categoryBilling: 'बिलिंग और सहायता',
    categoryBadges: 'बैज, अंक और लेवल',
    q15: 'बैज कैसे काम करते हैं, और मैं उन्हें कैसे अर्जित करूं?',
    a15: '',
    badgesFaq: {
      intro: 'बैज एक कोमल तरीका है जिससे हम Say It NOW पर आपके द्वारा बनाए गए सार्थक पलों को पहचानते हैं। ये प्रतिस्पर्धा के बारे में नहीं हैं — ये दिखने, अभिव्यक्त करने और जुड़े रहने के बारे में हैं।',
      howEarnedTitle: 'बैज कैसे अर्जित होते हैं',
      howEarnedSubtitle: 'बैज साइट पर विशिष्ट कार्यों से ट्रिगर होते हैं। यहां सभी वर्तमान में उपलब्ध बैज हैं:',
      badges: {
        firstExpression: { name: 'पहली अभिव्यक्ति', earned: 'अपना पहला लिविंग अनाउंसमेंट भेजने पर अर्जित।', trigger: 'आपके पहले प्रकाशन के बाद ट्रिगर।' },
        relationshipCelebrant: { name: 'रिलेशनशिप सेलिब्रेंट', earned: 'अपने जीवनसाथी के लिए अनाउंसमेंट बनाने पर अर्जित।', trigger: '"जीवनसाथी" रिश्ते के रूप में चुनने पर ट्रिगर।' },
        birthdayChampion: { name: 'बर्थडे चैंपियन', earned: 'अपनी महत्वपूर्ण तिथियों में जन्मदिन जोड़ने पर अर्जित।', trigger: 'सेटिंग्स → महत्वपूर्ण तिथियों में पाया जाता है।' },
        friendshipKeeper: { name: 'फ्रेंडशिप कीपर', earned: 'महत्वपूर्ण तिथियों में दोस्ती की सालगिरह जोड़ने पर अर्जित।', trigger: '', note: 'यह बैज सेटिंग्स → महत्वपूर्ण तिथियों में तिथि जोड़कर अर्जित होता है।' },
        consistencyStar: { name: 'कंसिस्टेंसी स्टार', earned: 'तीन या अधिक अलग-अलग हफ्तों में अनाउंसमेंट भेजने पर अर्जित।' },
        loveAmbassador: { name: 'लव एम्बेसडर', earned: 'चौदह दिनों के भीतर आठ या अधिक अनाउंसमेंट भेजने पर अर्जित।' },
      },
      levelsTitle: 'लेवल प्रगति',
      levelsSubtitle: 'जैसे-जैसे आप बैज अंक अर्जित करते हैं, आप लेवल अनलॉक करते हैं। लेवल कभी समाप्त नहीं होते।',
      levels: { heartOpener: 'हार्ट ओपनर', soulConnector: 'सोल कनेक्टर', loveAmbassador: 'लव एम्बेसडर', gratitudeChampion: 'ग्रैटिट्यूड चैंपियन', legacyMaker: 'लीगेसी मेकर' },
      pointsLabel: 'अंक',
      levelsNote: 'प्रत्येक लेवल निरंतर जुड़ाव और पहचान का प्रतिनिधित्व करता है।',
      dateNoteTitle: 'तिथियों के बारे में एक सहायक नोट',
      dateNoteBody: 'फ्रेंडशिप कीपर बैज के लिए विशेष रूप से सेटिंग्स → महत्वपूर्ण तिथियों में दोस्ती की सालगिरह जोड़ना आवश्यक है।',
      finalNote: 'बैज प्रतिबिंब और जुड़ाव को प्रोत्साहित करने के लिए हैं — दबाव के लिए नहीं। आपको उनका पीछा करने की ज़रूरत नहीं है।',
    },
    q1: 'Say It NOW क्या है?',
    a1: 'Say It NOW एक वेब प्लेटफ़ॉर्म है जो आपको प्यार और कृतज्ञता के सुंदर, मैगज़ीन-स्टाइल डिजिटल संदेश बनाने में मदद करता है — जब वे अभी भी देख, सुन और सराह सकते हैं।',
    q2: 'Say It NOW क्यों बनाया गया?',
    a2: 'Say It NOW इसलिए बनाया गया क्योंकि अक्सर, हम सुनते हैं कि कोई व्यक्ति कितना महान और प्यारा था उनके गुज़रने के बाद। Say It NOW लोगों को जानने में मदद करता है कि वे कितने प्यार और सराहे जाते हैं जब वे अभी भी महसूस कर सकते हैं।',
    q3: 'मैं किसे लिविंग अनाउंसमेंट भेज सकता/सकती हूं?',
    a3: 'आप किसी को भी लिविंग अनाउंसमेंट भेज सकते हैं — माता-पिता, दादा-दादी, भाई-बहन, बच्चे, जीवनसाथी, दोस्त, गुरु, सहकर्मी, या खुद को भी!',
    q4: 'Say It NOW सोशल मीडिया पोस्ट से कैसे अलग है?',
    a4: 'सोशल मीडिया पोस्ट के विपरीत जो फ़ीड में खो जाती हैं, Say It NOW सुंदर, व्यक्तिगत मैगज़ीन-स्टाइल अनाउंसमेंट बनाता है जो विशेष और जानबूझकर महसूस होते हैं।',
    q5: 'मुफ़्त प्लान में क्या शामिल है?',
    a5: 'मुफ़्त प्लान में 3 मुफ़्त अनाउंसमेंट, 1-3 फोटो अपलोड करने की क्षमता, रिश्ते चुनना, 2 AI सहायता उपयोग, और सार्थक संदेश तैयार करने में मदद करने वाले टेम्पलेट शामिल हैं।',
    q6: 'कौन सी AI सुविधाएं उपलब्ध हैं?',
    a6: 'हमारे कनेक्शन प्लान में AI-संचालित संदेश लेखन सहायता शामिल है। लीगेसी उपयोगकर्ताओं को AI ऑटो-कंपोज़ मिलता है।',
    q7: 'हार्टफेल्ट रिमाइंडर क्या हैं?',
    a7: 'हार्टफेल्ट रिमाइंडर 7 दिनों की निष्क्रियता के बाद भेजे जाने वाले कोमल संकेत हैं।',
    q8: 'AI ऑटो-कंपोज़ कैसे काम करता है?',
    a8: 'AI ऑटो-कंपोज़ (लीगेसी सुविधा) से, आप अपने प्राप्तकर्ताओं को उनके रिश्ते और व्यक्तिगत नोट्स के साथ सेट करते हैं। हमारा AI व्यक्तिगत, दिल से संदेश तैयार करता है।',
    q9: 'क्या मेरा डेटा निजी और सुरक्षित है?',
    a9: 'हां। आपके लिविंग अनाउंसमेंट डिफ़ॉल्ट रूप से निजी रहते हैं। आप नियंत्रित करते हैं कि कौन उन्हें देखता है।',
    q10: 'मैं लिविंग अनाउंसमेंट कैसे साझा करूं?',
    a10: 'एक बार बनाने और प्रकाशित करने के बाद, आपको एक अद्वितीय साझा करने योग्य लिंक मिलता है। आप इसे टेक्स्ट, ईमेल, या किसी भी मैसेजिंग प्लेटफ़ॉर्म से भेज सकते हैं।',
    q11: 'क्या मैं अपने अनाउंसमेंट संपादित या हटा सकता/सकती हूं?',
    a11: 'हां! आपके अनाउंसमेंट पर आपका पूरा नियंत्रण है। आप उन्हें कभी भी अपने डैशबोर्ड से संपादित कर सकते हैं।',
    q12: 'क्या क्रेडिट समाप्त होते हैं?',
    a12: 'नहीं! क्रेडिट कभी समाप्त नहीं होते। वे आपके अकाउंट में तब तक रहते हैं जब तक आप उनका उपयोग नहीं करते।',
    q13: 'क्या मैं बाद में और क्रेडिट जोड़ सकता/सकती हूं?',
    a13: 'बिल्कुल। आप कभी भी अतिरिक्त क्रेडिट खरीद सकते हैं या उच्च बंडल में अपग्रेड कर सकते हैं।',
    q14: 'अगर मुझे मदद चाहिए तो?',
    a14: 'हम मदद के लिए यहां हैं! लीगेसी उपयोगकर्ताओं को प्राथमिकता सहायता मिलती है। सभी उपयोगकर्ता हमारे संपर्क फ़ॉर्म के माध्यम से हमसे संपर्क कर सकते हैं।',
    contactTitle: 'अभी भी प्रश्न हैं?',
    contactSubtitle: 'हम प्यार व्यक्त करने की आपकी यात्रा में मदद करने के लिए यहां हैं। कभी भी संपर्क करें!',
    contactButton: 'मुफ़्त शुरू करें',
    contactEmail: 'सहायता से संपर्क करें',
  },
  jackey: {
    nudges: {
      firstExpression: 'आप आए। यह परफेक्ट होने से ज़्यादा मायने रखता है।',
      relationshipCelebrant: 'कुछ रिश्तों में ऐसे शब्द होते हैं जो हम हमेशा ज़ोर से नहीं कहते। आपने अभी कहा।',
      birthdayChampion: 'भविष्य के आप खुश होंगे कि आपने यह याद रखा।',
      friendshipKeeper: 'लंबी दोस्तियां ऐसे ही पलों से बनती हैं।',
      consistencyStar: 'आप उपस्थिति की एक लय बना रहे हैं — यह दुर्लभ है।',
      loveAmbassador: 'यह एक सिलसिला नहीं है। यह दिखने का एक मौसम है।',
      legacyBuilder: 'आप जो अभी बना रहे हैं वह इस पल से ज़्यादा टिकेगा।',
    },
  },
  header: { tagline: 'जब तक वे यहां हैं' },
  settings: {
    settings: 'सेटिंग्स',
    profile: 'प्रोफ़ाइल',
    preferences: 'प्राथमिकताएं',
    importantDates: 'महत्वपूर्ण तिथियां',
    autoCompose: 'ऑटो-कंपोज़',
    fullName: 'पूरा नाम',
    language: 'भाषा',
    save: 'सेव',
    saving: 'सेव हो रहा है...',
    saved: 'सेव हो गया!',
    error: 'सेव करने में त्रुटि',
  },
  creditDisplay: {
    heroHeadline: 'आज कौन याद आता है?',
    heroSubtext: 'कुछ शब्दों का मतलब दुनिया हो सकता है।',
    credits: 'क्रेडिट',
    createNew: 'नया बनाएं',
    addMore: 'और जोड़ें',
    aiAssists: 'AI सहायता',
    remaining: 'शेष',
  },
  founder: {
    badge: 'संस्थापक सदस्य',
    indicator: 'Say It NOW के संस्थापक सदस्य द्वारा भेजा गया',
    reminderBanner: 'आप अभी भी अपने संस्थापक सदस्य मूल्य के लिए पात्र हैं। रीलोड करने से आपकी $12 दर लॉक रहती है।',
    reminderSecondary: 'कोई दबाव नहीं — बस एक सूचना।',
    reload: 'अभी रीलोड करें',
    dismiss: 'खारिज करें',
    expiryTitle: 'संस्थापक सदस्य बनने के लिए धन्यवाद 💚',
    expiryText: 'आपकी संस्थापक विंडो बंद हो गई है, लेकिन आपके योगदान का स्थायी प्रभाव है।',
    expirySubtext: 'आप मानक दरों पर जारी रख सकते हैं।',
    expiryCta: 'प्लान देखें',
  },
  treslog: {
    inlineHintText: 'लिविंग अनाउंसमेंट आपको बाहर की ओर बोलने में मदद करते हैं। TRESLOG आपका निजी आजीवन स्थान है अंदर देखने के लिए।',
    inlineHintLink: 'TRESLOG के बारे में जानें',
    upsellTitle: 'आपका निजी आजीवन प्रतिबिंब स्थान',
    upsellText: 'TRESLOG गहन प्रतिबिंब, मूड ट्रैकिंग और आत्म-खोज के लिए आपकी व्यक्तिगत डायरी है।',
    upsellCta: 'TRESLOG अनलॉक करें',
  },
  postPublish: {
    title: '💚 आप आए।',
    subtitle: 'यही सबसे ज़्यादा मायने रखता है। आपके शब्द अब दुनिया में हैं।',
    share: 'साझा करें',
    dashboard: 'डैशबोर्ड पर जाएं',
  },
  mobile: { startWriting: 'लिखना शुरू करें', speak: 'बोलें' },
  security: { checkRequired: 'कृपया सुरक्षा जांच पूरी करें।', checkFailed: 'सुरक्षा जांच लोड होने में विफल।', verificationFailed: 'सुरक्षा सत्यापन विफल। कृपया पुनः प्रयास करें।', retry: 'पुनः प्रयास' },
  reveal: { identityRevealed: '✨ पहचान प्रकट', sentBy: 'यह संदेश भेजा गया', someoneWhoCares: 'कोई जो परवाह करता है', revealingSoon: 'पहचान जल्द ही प्रकट होगी…', revealInDays: 'भेजने वाले की पहचान {days} दिनों में प्रकट होगी', revealInOneDay: 'भेजने वाले की पहचान 1 दिन में प्रकट होगी' },
};
